import { useState, useEffect } from 'react';
import { calculateTimeDelta } from '../helpers/time.es.js';

const useTimer = (endAt) => {
  const [time, setTime] = useState(calculateTimeDelta(new Date(), endAt));
  useEffect(() => {
    setTime(calculateTimeDelta(new Date(), endAt));
    const timer = setInterval(() => setTime(calculateTimeDelta(new Date(), endAt)), 1e3);
    return () => {
      clearInterval(timer);
    };
  }, [endAt]);
  return time;
};

export { useTimer };
